import isString from 'lodash/isString'

function isPresent(value: unknown): value is string {
  return isString(value) && value.length > 0
}

export default isPresent
